export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-[#F8FAFB] to-[#F0F4F8] relative">
      {/* Decorative curve */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-[#E8F1F5] to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6">
        {/* Challenge section */}
        <div className="grid md:grid-cols-2 gap-16 items-center mb-32">
          <div className="space-y-6">
            <p className="text-xs uppercase tracking-widest text-[#2F7FB7] font-semibold">The Challenge</p>
            <h2 className="text-5xl font-serif text-[#2F7FB7] leading-tight">
              Too much information.<br />Not enough connection.
            </h2>
            <p className="text-lg text-[#4A5568] leading-relaxed">
              The mental health app market is growing rapidly, but many people feel overwhelmed by endless features, notifications, and content that doesn't truly meet their needs.
            </p>
            <p className="text-lg text-[#4A5568] leading-relaxed">
              What's often missing is the human element - the sense of being heard, understood, and supported.
            </p>
             <p className="text-lg text-[#4A5568] leading-relaxed">
              RECOVER offers a thoughtful, human-centered approach. Our content evolves by listening to your needs and growing together over time.
            </p>
          </div>

          {/* Right - Pain points */}
          <div className="space-y-5">
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-3xl shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 border border-[#D1E3EA]">
              <p className="text-[#4A5568] leading-relaxed">
                Many platforms attempt to cover everything at once, leaving users feeling lost and unheard.
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-3xl shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 border border-[#D1E3EA]">
              <p className="text-[#4A5568] leading-relaxed">
                AI-driven tools can feel emotionally distant from the support people are seeking.
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-3xl shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 border border-[#D1E3EA]">
              <p className="text-[#4A5568] leading-relaxed">
                Users are overwhelmed by impersonal advice that doesn't adapt to their unique needs.
              </p>
            </div>
          </div>
        </div>

        {/* Philosophy section */}
        <div className="mt-24 max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-5xl font-serif text-[#2F7FB7]">A Different Intention</h2>
          
          <p className="text-xl text-[#4A5568] leading-relaxed">
            RECOVER was created by a registered psychologist with over 40 years of experience working with people navigating anxiety, depression, burnout, Post-Traumatic Stress Disorder (PTSD), and life transitions.
          </p>

          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-10 shadow-lg border border-[#D1E3EA]">
            <div className="relative">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#2F7FB7] to-[#5A9FD4] rounded-full"></div>
              <div className="pl-12 space-y-6">
                <p className="text-lg text-[#4A5568] leading-relaxed text-left">
                  This isn't just another app. It's a thoughtfully designed space built on decades of real-world therapeutic practice, evidence-based approaches, and a deep understanding of what people actually need when they're struggling.
                </p>
                <p className="text-lg text-[#4A5568] leading-relaxed text-left">
                  Every feature, every piece of content, and every interaction has been carefully considered to feel supportive, not overwhelming - helpful, not intrusive.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
